import Cookies from 'js-cookie';

export const FBP_HEADER = 'X-FB-FBP';
export const FBP_COOKIE = '_fbp';

// Forwards Meta's _fbp browser cookie value as a request header so it reaches
// the Reverb backend through graphql-gateway, which strips cookies on
// upstream subgraph requests. Reverb reads it from Reverb::Context.fb_fbp and
// sends it on Facebook CAPI purchase events.
export function fbpHeader() {
  const fbp = Cookies.get(FBP_COOKIE);
  if (!fbp) return {};

  return {
    [FBP_HEADER]: fbp,
  };
}
